import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { NegativeAmounts } from "./components/NegativeAmounts";
import { AuthProvider, useAuth } from "./context/AuthContext";
import AppShell from "./components/AppShell";
import Login from "./pages/Login";
import AdminDashboard from "./pages/AdminDashboard";
import UploadReport from "./pages/UploadReport";
import Reports from "./pages/Reports";
import Agents from "./pages/Agents";
import AgentDetail from "./pages/AgentDetail";
import AgentPortal from "./pages/AgentPortal";
import Merchants from "./pages/Merchants";
import Account from "./pages/Account";
import { ForgotPasscode, ResetPasscode } from "./pages/PasscodeReset";

function Guard({ role, children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen grid place-items-center text-slate-500 font-mono text-sm">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) return <Navigate to={user.role === "admin" ? "/admin" : "/portal"} replace />;
  return <AppShell>{children}</AppShell>;
}

function Home() {
  const { user } = useAuth();
  if (user === null) return null;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "admin" ? "/admin" : "/portal"} replace />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/admin" element={<Guard role="admin"><AdminDashboard /></Guard>} />
          <Route path="/admin/upload" element={<Guard role="admin"><UploadReport /></Guard>} />
          <Route path="/admin/reports" element={<Guard role="admin"><Reports /></Guard>} />
          <Route path="/admin/agents" element={<Guard role="admin"><Agents /></Guard>} />
          <Route path="/admin/agents/:id" element={<Guard role="admin"><AgentDetail /></Guard>} />
          <Route path="/admin/merchants" element={<Guard role="admin"><Merchants /></Guard>} />
          <Route path="/admin/account" element={<Guard role="admin"><Account /></Guard>} />
          <Route path="/portal/account" element={<Guard role="agent"><Account /></Guard>} />
          <Route path="/forgot-passcode" element={<ForgotPasscode />} />
          <Route path="/reset-passcode" element={<ResetPasscode />} />
          <Route path="/portal" element={<Guard role="agent"><AgentPortal /></Guard>} />
          <Route path="*" element={<Home />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-right" />
      <NegativeAmounts />
    </AuthProvider>
  );
}

export default App;
